/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext } from 'react';

import { RicosContext, ToolbarContext } from './../../../../ricos-context';
import {
  getIsModalOpen,
  useModalService,
  useModalState,
} from './../../../../ricos-modals/modal-service-provider';
import type { IToolbarItem } from './../../../../ricos-types';
import { PLUGIN_MENU_MODAL_ID } from './../../../../ricos-types';

import { ToolbarButton } from '../ToolbarButton';

const AddPluginMenuButton = ({ toolbarItem }: { toolbarItem: IToolbarItem }) => {
  const active = useModalState(getIsModalOpen(PLUGIN_MENU_MODAL_ID));
  const { isMobile, t } = useContext(RicosContext);
  const { toolbars } = useContext(ToolbarContext);
  const modalService = useModalService();

  const onClick = (e: Event) =>
    modalService.isModalOpen(PLUGIN_MENU_MODAL_ID)
      ? modalService.closeModal(PLUGIN_MENU_MODAL_ID)
      : modalService.openRegisteredModal(PLUGIN_MENU_MODAL_ID, {
          positioning: { placement: 'bottom', referenceElement: e.target },
          layout: isMobile ? 'drawer' : 'popover',
        });
  const tooltip = t?.(toolbarItem.presentation?.tooltip);

  return (
    <ToolbarButton
      isMobile={isMobile}
      active={active}
      tooltip={tooltip}
      onClick={toolbars?.pluginMenu.getSettings()?.onClick || onClick}
      icon={toolbarItem.presentation?.icon}
    />
  );
};

export default AddPluginMenuButton;
